import type { DocPageContent } from '../docs-content'

const page = {
  order: 19,
  slug: 'render-queue',
  title: '渲染队列',
  description: '排队导出、分割范围、暂停、继续、重试和管理已保存的导出。',
  category: '输出',
  sections: [
    {
      title: '队列任务',
      items: [
        '将当前导出设置添加到渲染队列。',
        '排队整个项目或当前范围。',
        '按每个标记将工作分割为一段。',
        '将长时间的工作分割为定时块。',
      ],
    },
    {
      title: '管理队列状态',
      items: [
        '排队的导出任务依次渲染。',
        '暂停和继续队列。',
        '当顺序重要时向上或向下移动任务。',
        '取消、移除、重试或清除已完成的任务。',
      ],
    },
    {
      title: '已保存的导出',
      items: [
        '使用"已保存的导出"标签页查看已完成文件。',
        '下载、刷新或删除已保存的导出记录。',
        '在工作区内的项目本地文件夹中找到导出的文件。',
      ],
    },
  ],
} satisfies DocPageContent

export default page